export default {
    action: {
        trendradar: 'Trend radar',
        recommendation: 'Recommendation for action',
        readiness: 'Readiness assessment'
    },
    macrotrends: {
        title: 'Macro-trends',
        subtitle: 'Macro-trends in focus:'
    },
    slider: {
        related: 'Related micro-trends'
    },
    pageTitle: 'VIEW - TREND RADAR'
}
